import React from 'react';
import { Button } from '@lwt-helix/buttons';
import Loader from '@lwt-helix/loader';
import { buttonTerms, searchTerms } from '../../../../constants';
import Icon from '@lwt-helix/icon';
import { HelixIcon } from '@lwt-helix/helix-icon';
import { arrows_exchange } from '@lwt-helix/helix-icon/outlined';
import { chipIconProps } from '../../../helpers/chips';
import EditListModal from './EditListModal';

const TransferList = props => {
    const {
        renderedAvailableItems,
        renderedAddedItems,
        addAll,
        removeAll,
        showEditModal,
        closeEditModal,
        modalIsOpen,
        selectedList,
        selectedItems,
        saveList,
        updateList,
        availableWidth,
        addedWidth,
        disabled,
        editModalHeader,
        idProperty,
        isDirty,
        isLoadingAddedItems,
        shouldHideSaveAsListButton,
        isAddAllDisabled,
        addSelected,
        removeSelected,
        checkedAddedOffices,
        checkedAvailableOffices
    } = props;

    return (
        <div className={`w-100 d-inline-block transfer-list-menu ${idProperty}`} >
            <div className="available-column-wrapper" style={{ width: availableWidth || '48%' }}>
                <div className="transfer-column-header">
                    <span className="helix-body--strong">Available</span>
                </div>
                <div className="available-items transfer-items-list">
                    {renderedAvailableItems}
                </div>
                <div className="add-controls float-left">
                    <Button
                        dataLwtId="add-all"
                        color="secondary"
                        onClick={addAll}
                        disabled={isAddAllDisabled}
                    >
                        {buttonTerms.all} {'>'}
                    </Button>
                    {checkedAvailableOffices && <Button
                        dataLwtId="add-selected"
                        color="secondary"
                        onClick={addSelected}
                        disabled={isAddAllDisabled}
                    >
                        {buttonTerms.selected} {`> (${checkedAvailableOffices?.length})`}
                    </Button>}
                </div>
            </div>
            <div className="transfer-column-separator">
                <div className="transfer-list-bar" />
                <div className="transfer-icon">
                    <HelixIcon icon={arrows_exchange} {...chipIconProps} title="exchange icon" />
                </div>
                <div className="transfer-list-bar" />
            </div>
            <div className="added-column-wrapper" style={{ width: addedWidth || '48%' }}>
                <div className="transfer-column-header">
                    <span className="helix-body--strong">Added</span>
                    {!shouldHideSaveAsListButton && <Button
                        dataLwtId="edit-list"
                        size="sm"
                        color="light"
                        className="text-capitalize"
                        id="edit-list"
                        onClick={showEditModal}
                        style={{ padding: '0 0 2px 0' }}
                        disabled={disabled}
                    >
                        <Icon className="mr-1 text-primary" iconName="add_circle" dataLwtId="add-icon" />
                        {selectedList ? searchTerms.saveList : searchTerms.saveAsList}
                    </Button>}
                </div>
                <EditListModal
                    key="transfer-edit-list"
                    closeEditModal={closeEditModal}
                    modalIsOpen={modalIsOpen}
                    initialList={selectedList}
                    idProperty={idProperty}
                    onSaveNew={saveList}
                    onUpdate={updateList}
                    disabled={disabled}
                    headerContent={editModalHeader}
                    isDirty={isDirty}
                />
                <div className="added-items transfer-items-list">
                    {isLoadingAddedItems ? <Loader /> : renderedAddedItems}
                </div>
                <div className="remove-controls float-right">
                    {checkedAddedOffices && <Button
                        dataLwtId="remove-selected"
                        color="secondary"
                        onClick={removeSelected}
                        disabled={!selectedItems?.length}
                    >
                        {`(${checkedAddedOffices?.length}) < `} {buttonTerms.selected}
                    </Button>}
                    <Button
                        dataLwtId="remove-all"
                        color="secondary"
                        onClick={removeAll}
                        disabled={!selectedItems?.length}
                    >
                        {'< '}
                        {buttonTerms.all}
                    </Button>
                </div>
            </div>
        </div>
    );
};
export default TransferList;
